// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProgressBar-base__XpgXF{position:relative;width:var(--size-full);min-width:var(--size-20);height:var(--size-1);overflow:hidden;background:var(--gray-a4);border-radius:var(--border-radius-6)}.ProgressBar-indicator___I9Qf{flex-shrink:0;width:var(--size-full);height:var(--size-1);background:var(--gray-12);border-radius:var(--border-radius-6);transition:all 150ms cubic-bezier(0.4, 0, 0.2, 1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ProgressBar-base__XpgXF",
	"indicator": "ProgressBar-indicator___I9Qf"
};
export default ___CSS_LOADER_EXPORT___;
